var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.291,
    height: 16.715,
    viewBox: "0 0 17.291 16.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dashboard",
    d: "M11.3,15.865H4.292A5.07,5.07,0,0,1,.539,14.378,5.178,5.178,0,0,1-.85,10.691V4.325A5.179,5.179,0,0,1,.542.636,5.068,5.068,0,0,1,4.292-.85H11.3A5.07,5.07,0,0,1,15.053.636a5.181,5.181,0,0,1,1.389,3.688v6.366a5.178,5.178,0,0,1-1.389,3.688A5.072,5.072,0,0,1,11.3,15.865ZM4.292.364A3.88,3.88,0,0,0,1.418,1.479,3.992,3.992,0,0,0,.367,4.325v6.366a3.992,3.992,0,0,0,1.048,2.845,3.882,3.882,0,0,0,2.877,1.115H11.3a3.884,3.884,0,0,0,2.877-1.115,3.992,3.992,0,0,0,1.048-2.845V4.325a3.994,3.994,0,0,0-1.048-2.846A3.881,3.881,0,0,0,11.3.364ZM11.256,12.3a1.16,1.16,0,0,1-1.169-1.148V8.825a1.17,1.17,0,0,1,2.339,0v2.333A1.16,1.16,0,0,1,11.256,12.3Zm-3.432,0a1.16,1.16,0,0,1-1.169-1.148V3.845a1.17,1.17,0,0,1,2.339,0v7.313A1.16,1.16,0,0,1,7.824,12.3Zm-3.489,0a1.16,1.16,0,0,1-1.169-1.148V6.211a1.169,1.169,0,0,1,2.338,0v4.946A1.16,1.16,0,0,1,4.335,12.3Z",
    transform: "translate(0.85 0.85)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDashboard);
export default __webpack_public_path__ + "static/media/Nav-Dashboard.323fdda977bc5a170814733e1c193e7c.svg";
export { ForwardRef as ReactComponent };